/* eslint-disable no-template-curly-in-string */
import React, {
  Dispatch,
  SetStateAction,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import styled from 'styled-components';
import { Checkbox, Col, Row } from 'antd';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import * as _ from 'lodash';

import styles from 'app/pages/Cart/components/PaymentInfo/styles.module.css';
import StyledButton from 'app/components/StyledButton';
import { formatNumber } from 'utils/helper';
import { OrderContext } from '../..';
import {
  selectInfoUser,
  selectTranslations,
} from 'app/pages/App/slice/selectors';
import { useGlobalFunction } from 'app/pages/App/hooks/useGlobalFunction';
import {
  GET_LIST_PAYMENT_METHOD,
  useCheckoutSlice,
} from 'app/pages/Checkout/slice';
import {
  selectListDeliverTicketType,
  selectListPaymentMethod,
} from 'app/pages/Checkout/slice/selectors';
import { ReactComponent as PaymentIcon } from 'app/assets/img/payment_icon.svg';
import { ReactComponent as TicketFormIcon } from 'app/assets/img/ticket-form.svg';
import { DESKTOP_WIDTH } from 'app/hooks/useWindowSize';
import { I_UpdateOrderData } from '../../hooks/useOrder';
import { generateTicketIdentify } from 'app/pages/Cart/utils';
import moment from 'moment';
import {
  BP_TYPE,
  DELIVER_TICKET_TYPE_CODE,
  MAP_VGS,
  TICKET_TYPES,
} from 'utils/constants';
import checkHaveTicketOnSelectedDate from 'app/pages/Cart/components/TicketItem/partials/helper';
import { UTC_OFFSET } from 'utils/hooks/useCountDown';

enum UPDATE_ORDER_ERROR_CODE {
  NOT_ENOUGH_INVENTORY = 'MSG020',
  TICKET_NOT_EXISTS = 'MSG026',
  SO_NOT_ENOUGH_INVENTORY = 'MSG050',
  SO_FAILED = 'MSG032',
  ORDER_CANCELED = 'MSG070',
  ORDER_SUCCESSED = 'MSG071',
  ORDER_IS_PAYMENT_PROGRESSING = 'MSG080',
  TICKET_BLOCKED = 'MSG100',
  TIMEOUT_EDIT = 'MSG101',
  NOT_ALLOW_PAPER_TICKET = 'MSG036',
}

interface PaymentInfoProps {
  enablePaymentAction: boolean;
  setEnablePaymentAction: Dispatch<SetStateAction<boolean>>;
  onTimeoutEditOrder: () => void;
  handleAddons: (action: 'PAY' | 'UPDATE') => Promise<void>;
  listItems: any;
  readyToProcess: Record<string, 'IDLE' | 'PENDING' | 'READY'>;
  isShowAddonsModal: boolean;
  shouldShowAddonsModal: boolean;
  setReadyToProcess: Dispatch<
    SetStateAction<Record<string, 'IDLE' | 'PENDING' | 'READY'>>
  >;
  orderDetail: Record<string, any>;
  setDisableCreateOrder: Dispatch<React.SetStateAction<boolean>>;
  disableCreateOrder: boolean;
  hasChangeProperty: React.MutableRefObject<boolean>;
  bpAllocatedDebt?: number | null;
}

const PaymentInfo = (props: PaymentInfoProps) => {
  const {
    enablePaymentAction,
    setEnablePaymentAction,
    onTimeoutEditOrder,
    handleAddons,
    listItems,
    readyToProcess,
    isShowAddonsModal,
    shouldShowAddonsModal,
    setReadyToProcess,
    orderDetail,
    disableCreateOrder,
    hasChangeProperty,
    bpAllocatedDebt,
  } = props;

  const params: { hashId: string } = useParams();
  const orderHashId = params?.hashId;
  const {
    paymentMethod,
    setPaymentMethod,
    onChangePaymentMethod,
    deliverTicketType,
    setDeliverTicketType,
    totalNumberTickets,
    totalPrice,
    onUpdateOrder,
    ticketList,
    orderId,
    orderIdHash,
    onUpdateTicketList,
    pendingCountdownOrder,
    setIsLoading,
    setIsSubmitted,
  } = useContext(OrderContext);
  const dispatch = useDispatch();
  useCheckoutSlice();

  const infoUser = useSelector(selectInfoUser);

  const listPaymentMethod = useSelector(selectListPaymentMethod);
  const listDeliverTicketType = useSelector(selectListDeliverTicketType);
  const [deliverTicketTypeList, setDeliverTicketTypeList] = useState<
    Record<string, any>[]
  >([]);
  const [actionType, setActionType] = useState<'PAY' | 'UPDATE' | null>(null);

  const { onOpenDialogNoti, onCloseDialogNoti } = useGlobalFunction();

  const history = useHistory();

  const translations = useSelector(selectTranslations);

  useEffect(() => {
    const isProxyBuyer =
      (infoUser?.businessPartner as any)?.bpType === BP_TYPE.PROXY_BUYER;
    dispatch(
      GET_LIST_PAYMENT_METHOD({
        ticketType: sessionStorage.getItem('ticketType'),
        ...(isProxyBuyer && { bpAllocatedDebt }),
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    const canBuyPaperTicket: boolean = (() => {
      const isProxyOrder = !!orderDetail?.businessPartnerAllocatedDebt;
      if (isProxyOrder)
        return orderDetail?.businessPartnerAllocatedDebt?.allowBuyPaperTicket;
      else return infoUser?.businessPartner?.allowBuyPaperTicket;
    })();

    const deliverTicketTypes = canBuyPaperTicket
      ? listDeliverTicketType
      : listDeliverTicketType.filter(
          i => i?.code !== DELIVER_TICKET_TYPE_CODE.PAPER_TICKET,
        );

    if (deliverTicketTypes.length > 0) {
      const currentDeliverTicketType = orderDetail?.deliverTicketType;
      const isValidCurrentDeliver = deliverTicketTypes?.some(
        i => i?.id === currentDeliverTicketType?.id,
      );

      if (isValidCurrentDeliver) {
        setDeliverTicketType(currentDeliverTicketType?.id);
      } else {
        const eDeliverType = deliverTicketTypes.find(
          i => _.isEmpty(i?.code) || i?.id === 27964,
        );
        setDeliverTicketType(eDeliverType?.id ?? deliverTicketTypes?.[0]?.id);

        onOpenDialogNoti({
          type: 'ERROR',
          isShow: true,
          title: translations?.['b2b.txt.noApplyPaperTicket'] ?? '',
          content: '',
          maskClosable: false,
          onCloseDialog: onCloseDialogNoti,
        });
      }

      setDeliverTicketTypeList(deliverTicketTypes);
    }
  }, [
    infoUser?.businessPartner?.allowBuyPaperTicket,
    listDeliverTicketType,
    onCloseDialogNoti,
    onOpenDialogNoti,
    orderDetail?.businessPartnerAllocatedDebt,
    orderDetail?.deliverTicketType,
    setDeliverTicketType,
    translations,
  ]);

  const renderMessCofirmLogout = useCallback((message: string) => {
    const partsOfMsg = message.split('\\n\\r');
    return partsOfMsg.map((i, idx) => (
      <UpdateOrderConfirmMsg
        key={idx}
        dangerouslySetInnerHTML={{ __html: i }}
      />
    ));
  }, []);

  const handleUpdateOrder = useCallback(
    async (action: 'PAY' | 'UPDATE') => {
      if (actionType) return false;
      setActionType(action);
      setIsLoading(true);
      setIsSubmitted(true);
      const dataUpdate: I_UpdateOrderData[] = (
        listItems?.length === 0 ? ticketList : [...listItems]
      ).map(ticket => ({
        item_id: ticket?.isAddon ? 0 : ticket?.id,
        amount: ticket?.amount,
        show_id: ticket?.isAddon ? ticket?.id : ticket?.show?.id,
        date: ticket?.isAddon ? ticket?.date : ticket?.date?.dateOrigin,
        restaurant_id: ticket?.restaurant?.id,
        used_area2: ticket?.product?.usedArea2Object?.value,
        zone_id: ticket?.zone?.id,
      }));
      let isHasErrorData = false;
      let firstErrorId: string = '';
      let listCartClone = JSON.parse(JSON.stringify(ticketList));

      ticketList.forEach(ticket => {
        const isNotApplyUsedArea2 =
          ticket?.show?.materialType === TICKET_TYPES.CABLE_CAR;
        const isNotApplyZone =
          ticket?.show?.materialType === TICKET_TYPES.CABLE_CAR ||
          _.isNil(ticket?.zone) ||
          _.isEmpty(ticket?.zone);
        const isRestaurantTicket =
          ticket.show?.restaurants &&
          ticket.show?.restaurants?.length > 0 &&
          ticket?.show?.materialType !== TICKET_TYPES.CABLE_CAR;

        const isComboDifTicket =
          ticket.catalog?.mapVGS === MAP_VGS.COMBO &&
          ticket.product?.park?.workstationId === 'DIF';

        const isHaveTicketOnSelectedDate = checkHaveTicketOnSelectedDate({
          selectedDate: moment(ticket.date.dateOrigin, 'YYYY-MM-DD'),
          dateFrom: moment(ticket.show?.dateFrom?.dateOrigin, 'YYYY-MM-DD'),
          dateTo: moment(ticket.show?.dateTo?.dateOrigin, 'YYYY-MM-DD'),
          isComboDifTicket,
          weekend: ticket.show?.weekend,
          fireworkDay: ticket.show?.fireworkDay,
        });

        if (
          (ticket?.errorTicket &&
            ticket.errorTicket !==
              (translations?.['b2b.txt.max10000tickets'] ?? '')) ||
          ticket?.errorTime ||
          !isHaveTicketOnSelectedDate ||
          !+(ticket?.inventory ?? 0) ||
          (!ticket?.zone?.id && !isNotApplyZone) ||
          (!ticket?.product?.usedArea2Object?.value && !isNotApplyUsedArea2) ||
          ((ticket?.usedAreas2 ?? [])?.length < 1 && !isNotApplyUsedArea2) ||
          (isRestaurantTicket && !ticket?.restaurant?.id)
        ) {
          isHasErrorData = true;
          if (!firstErrorId) firstErrorId = ticket.identify!;
        }
      });

      try {
        if (isHasErrorData) return false;
        const response = await onUpdateOrder(
          +(paymentMethod ?? 0),
          deliverTicketType!,
          dataUpdate,
        );
        if (response?.status === 200) {
          if (action === 'PAY')
            return history.push({
              pathname: `/update-order-info`,
              search: `order_id=${orderIdHash}`,
              state: {
                prevPage: 'EDIT_ORDER',
              },
            });
          onOpenDialogNoti({
            type: 'SUCCESS',
            isShow: true,
            title: '',
            content:
              translations?.['b2b.txt.updateOrderSuccess']?.replaceAll(
                '{code}',
                `${orderId}`,
              ) ?? '',
            buttons: [
              {
                text: translations?.['b2b.btn.confirm'] ?? '',
                bg: 'linear-gradient(79.97deg, #F06F24 -7.79%, #F8B117 107.61%)',
                color: 'white',
                onClick: () => {
                  onCloseDialogNoti();
                  history.push(`/account`);
                },
              },
            ],
            maskClosable: false,
            closable: false,
          });
        }
      } catch (err: any) {
        const errData = err?.data;
        if (errData) {
          const errCode = errData?.code;
          // Call SO failed, order canceled
          if (errCode === UPDATE_ORDER_ERROR_CODE.SO_FAILED) {
            onOpenDialogNoti({
              type: 'ERROR',
              isShow: true,
              title: '',
              content: err?.message,
              buttons: [],
              maskClosable: false,
              closable: true,
              onCloseDialog: () => {
                onCloseDialogNoti();
                history.push({
                  pathname: '/account',
                  state: {
                    targetTab: 'tab-3',
                  },
                });
              },
            });
            return;
          } else if (errCode === UPDATE_ORDER_ERROR_CODE.TICKET_NOT_EXISTS) {
            onOpenDialogNoti({
              type: 'ERROR',
              isShow: true,
              title: '',
              content: renderMessCofirmLogout(
                translations?.['b2b.txt.msg026'] ?? '',
              ),
              buttons: [],
              maskClosable: false,
              closable: true,
              onCloseDialog: onCloseDialogNoti,
            });
          } else if (
            errCode === UPDATE_ORDER_ERROR_CODE.NOT_ENOUGH_INVENTORY ||
            errCode === UPDATE_ORDER_ERROR_CODE.SO_NOT_ENOUGH_INVENTORY
          ) {
          } else if (errCode === UPDATE_ORDER_ERROR_CODE.ORDER_CANCELED) {
            onOpenDialogNoti({
              type: 'ERROR',
              isShow: true,
              title: '',
              content: err?.message,
              buttons: [],
              maskClosable: false,
              closable: true,
              onCloseDialog: () => {
                onCloseDialogNoti();
                history.push({
                  pathname: '/account',
                  state: {
                    targetTab: 'tab-3',
                  },
                });
              },
            });
          } else if (
            errCode === UPDATE_ORDER_ERROR_CODE.ORDER_SUCCESSED ||
            errCode === UPDATE_ORDER_ERROR_CODE.ORDER_IS_PAYMENT_PROGRESSING
          ) {
            onOpenDialogNoti({
              type: 'ERROR',
              isShow: true,
              title: '',
              content: err?.message,
              buttons: [],
              maskClosable: false,
              closable: true,
              onCloseDialog: () => {
                onCloseDialogNoti();
                history.push({
                  pathname: '/account',
                  state: {
                    targetTab:
                      errCode === UPDATE_ORDER_ERROR_CODE.ORDER_SUCCESSED
                        ? 'tab-1'
                        : 'tab-2',
                  },
                });
              },
            });
          } else if (errCode === UPDATE_ORDER_ERROR_CODE.TIMEOUT_EDIT) {
            onOpenDialogNoti({
              type: 'ERROR',
              isShow: true,
              title: '',
              content: err?.message,
              buttons: [],
              maskClosable: false,
              closable: true,
              onCloseDialog: () => {
                onCloseDialogNoti();
                onTimeoutEditOrder();
              },
            });
          } else if (err?.action?.toLowerCase() === 'popup') {
            if (
              err?.data?.errorCode ===
              UPDATE_ORDER_ERROR_CODE.NOT_ALLOW_PAPER_TICKET
            ) {
              console.log(deliverTicketType, deliverTicketTypeList);

              setDeliverTicketTypeList(prev =>
                prev.filter(item => {
                  const isPaperTicket =
                    item?.code === DELIVER_TICKET_TYPE_CODE.PAPER_TICKET;

                  if (!isPaperTicket) {
                    setDeliverTicketType(item?.id);
                  }

                  return !isPaperTicket;
                }),
              );
            }
            onOpenDialogNoti({
              type: 'ERROR',
              isShow: true,
              title: '',
              content: err?.message,
              buttons: [],
              maskClosable: false,
              closable: true,
              onCloseDialog: onCloseDialogNoti,
            });
          } else if (err?.data?.length === 0) {
            onOpenDialogNoti({
              type: 'ERROR',
              isShow: true,
              title: '',
              content: err?.message,
              buttons: [],
              maskClosable: false,
              closable: true,
              onCloseDialog: () => {
                onCloseDialogNoti();
              },
            });
          } else if (
            (err?.message === 'errorTicket' &&
              err?.data?.errorType === 'errorTicket' &&
              listItems?.length > 0) ||
            (err?.message === 'errorTicket' &&
              err?.data?.errorType === 'errorTicket')
          ) {
            onOpenDialogNoti({
              type: 'ERROR',
              isShow: true,
              title: '',
              content: translations?.['b2b.txt.invalidTicket'] ?? '',
              buttons: [],
              maskClosable: false,
              closable: true,
              onCloseDialog: () => {
                onCloseDialogNoti();
              },
            });
          }
          const dataInventory = errData?.dataInventory || [];
          const dataRequest = errData?.dataRequest || [];
          if (
            (_.isArray(dataInventory) && dataInventory.length > 0) ||
            (_.isArray(dataRequest) && dataRequest.length > 0)
          ) {
            isHasErrorData = true;
            const dataError = [...dataRequest, ...dataInventory];
            dataError?.forEach(i => {
              const isJumpValueError =
                i?.errorCode === 'jumpTicket' || i?.errorCode === 'minTicket';
              const errIdentify = generateTicketIdentify({
                showId: i?.show_id,
                performanceId: undefined,
                zoneId: i?.zone_id,
                date: i?.date,
                restaurantId: i?.restaurant_id,
                usedArea2: i?.used_area2,
              });
              if (!firstErrorId) firstErrorId = errIdentify;
              listCartClone = listCartClone.map(item => {
                if (item?.identify !== errIdentify) return { ...item };
                const getInventory = () => {
                  if (i?.inventory) return +i.inventory;
                  return +item.inventory;
                };
                return {
                  ...item,
                  inventory: getInventory(),
                  errorTicket: isJumpValueError
                    ? i?.message
                    : errCode ===
                        UPDATE_ORDER_ERROR_CODE.NOT_ENOUGH_INVENTORY ||
                      errCode ===
                        UPDATE_ORDER_ERROR_CODE.SO_NOT_ENOUGH_INVENTORY
                    ? err?.message
                    : null,
                  errorTime:
                    errCode === UPDATE_ORDER_ERROR_CODE.TICKET_NOT_EXISTS
                      ? err?.message
                      : errCode === UPDATE_ORDER_ERROR_CODE.TICKET_BLOCKED
                      ? i?.message
                      : null,
                  jumpTicket: isJumpValueError ? i.jumpTicket : undefined,
                  minAmountTicket: isJumpValueError ? i.minAmount : undefined,
                };
              });
            });
          }
        }
      } finally {
        if (isHasErrorData) {
          onUpdateTicketList(listCartClone);
          const y =
            (document.getElementById(firstErrorId)?.getBoundingClientRect()
              ?.top ?? 0) +
            window.pageYOffset -
            160;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
        setActionType(null);
        setIsLoading(false);
      }
    },
    [
      actionType,
      deliverTicketType,
      history,
      onCloseDialogNoti,
      onOpenDialogNoti,
      onTimeoutEditOrder,
      onUpdateOrder,
      onUpdateTicketList,
      orderId,
      orderIdHash,
      paymentMethod,
      renderMessCofirmLogout,
      setIsLoading,
      ticketList,
      translations,
    ],
  );

  const onConfirmUpdateOrder = useCallback(
    (action: 'PAY' | 'UPDATE') => {
      onOpenDialogNoti({
        type: 'ERROR',
        isShow: true,
        title: '',
        content: renderMessCofirmLogout(
          translations?.['b2b.txt.cfUpdateOrderMsg'] ?? '',
        ),
        buttons: [
          {
            text: translations?.['b2b.btn.cancel'] ?? '',
            bg: '#ffff',
            border: 'solid 1px #808080',
            color: '#808080',
            onClick: () => {
              onCloseDialogNoti();
            },
          },
          {
            text: translations?.['b2b.btn.confirm'] ?? '',
            bg: 'linear-gradient(79.97deg, #F06F24 -7.79%, #F8B117 107.61%)',
            color: 'white',
            onClick: () => {
              handleUpdateOrder(action);
              onCloseDialogNoti();
            },
          },
        ],
        maskClosable: false,
        closable: false,
      });
    },
    [
      handleUpdateOrder,
      onCloseDialogNoti,
      onOpenDialogNoti,
      renderMessCofirmLogout,
      translations,
    ],
  );

  useEffect(() => {
    if (
      (!isShowAddonsModal && readyToProcess.update === 'READY') ||
      (!shouldShowAddonsModal && readyToProcess.update === 'PENDING')
    ) {
      onConfirmUpdateOrder.bind(null, 'UPDATE')();
      setReadyToProcess({
        update: 'IDLE',
        pay: 'IDLE',
      });
    }
    if (
      (!isShowAddonsModal && readyToProcess.pay === 'READY') ||
      (!shouldShowAddonsModal && readyToProcess.pay === 'PENDING')
    ) {
      onConfirmUpdateOrder.bind(null, 'PAY')();
      setReadyToProcess({
        update: 'IDLE',
        pay: 'IDLE',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [readyToProcess, shouldShowAddonsModal]);

  const onGoBack = async () => {
    try {
      setIsLoading(true);
      await pendingCountdownOrder(orderHashId, '0');
    } finally {
      setIsLoading(false);
      history.goBack();
    }
  };

  const handleChangePaymentMethod = e => {
    const value = e.target.value;
    const paymentSelected = listPaymentMethod.find(val => val.id === value);

    const hourFrom = paymentSelected?.validFrom;
    const hourTo = paymentSelected?.validTo;

    if (hourFrom && hourTo) {
      const parseHourFrom = moment(hourFrom, 'HH:mm').format('HH');
      const parseHourTo = moment(hourTo, 'HH:mm').format('HH');
      const parseMinuteFrom = moment(hourFrom, 'HH:mm').format('mm');
      const parseMinuteTo = moment(hourTo, 'HH:mm').format('mm');
      const currentDate = moment().utcOffset(UTC_OFFSET);
      const currentHour = currentDate.hours() + currentDate.minutes() / 60;
      const isValidHour =
        currentHour >=
          parseInt(parseHourFrom, 10) + parseInt(parseMinuteFrom, 10) / 60 &&
        currentHour <
          parseInt(parseHourTo, 10) + parseInt(parseMinuteTo, 10) / 60;
      if (!isValidHour) {
        onOpenDialogNoti({
          type: 'ERROR',
          title: '',
          content: translations?.['b2b.txt.payment_notice_2']?.replace(
            '${payment}',
            paymentSelected?.name,
          ),
          isShow: true,
          buttons: [],
          maskClosable: false,
          closable: true,
          onCloseDialog: onCloseDialogNoti,
        });
        return;
      }
    }

    hasChangeProperty.current = true;
    setEnablePaymentAction(true);
    onChangePaymentMethod(value);
    setPaymentMethod(value);
  };

  const handleChangeDeliverTicketType = e => {
    const value = e.target.value;
    setDeliverTicketType(value);
    setEnablePaymentAction(true);
  };
  const isProxyBuyer =
    (infoUser?.businessPartner as any)?.bpType === BP_TYPE.PROXY_BUYER;
  const PaymentNoticeTradeDiscount = () => {
    const paymentNotice = useMemo(() => {
      const detail = listPaymentMethod?.find(val => val.id === paymentMethod);
      const commission = detail?.commission;
      if (!commission) return '';
      const formattedAmount = `${formatNumber(
        detail.code === 'CommissionMou'
          ? commission?.availableAmount || 0
          : commission?.availableAmount || 0,
      ).replaceAll(',', '.')}đ`;
      const formattedDate = commission?.validTo
        ? moment(commission.validTo.toString(), 'YYYYMMDD').format('DD/MM/YYYY')
        : '';
      return (
        translations?.[
          detail.code === 'CommissionMou'
            ? 'b2b.txt.payment_notice_trade_discount'
            : 'b2b.txt.payment_notice_trade_discount'
        ]
          ?.replace('${X}', formattedAmount)
          ?.replace('${end_date}', formattedDate) || ''
      );
    }, [paymentMethod]);
    if (!paymentNotice) return null;
    return (
      <i style={{ fontSize: 14, color: '#000000', marginTop: 8 }}>
        {paymentNotice}
      </i>
    );
  };

  return (
    <Container>
      {listPaymentMethod?.length > 0 && (
        <PaymentMethodComponent>
          <div className="title d-flex align-items-center">
            <PaymentIcon />
            <h3>{translations?.['b2b.table.payment'] ?? ''}</h3>
          </div>
          <div className={styles.checkboxContainer}>
            {listPaymentMethod.map(i => {
              const value = i?.id;
              return (
                <StyledCheckbox
                  key={value}
                  checked={value === paymentMethod}
                  value={value}
                  onChange={handleChangePaymentMethod}
                >
                  <span style={{ textTransform: 'uppercase' }}>
                    {i?.name || i?.code}
                  </span>
                </StyledCheckbox>
              );
            })}
            {listPaymentMethod?.find(val => val.id == paymentMethod)
              ?.validFrom && (
              <i style={{ fontSize: 14, color: '#000000', marginTop: 8 }}>
                {`${
                  translations
                    ? translations['b2b.txt.payment_notice_1']
                        ?.replace(
                          '${payment}',
                          listPaymentMethod?.find(
                            val => val.id == paymentMethod,
                          )?.name,
                        )
                        ?.replace(
                          '${hour_from}',
                          listPaymentMethod?.find(
                            val => val.id == paymentMethod,
                          )?.validFrom,
                        )
                        ?.replace(
                          '${hour_to}',
                          listPaymentMethod?.find(
                            val => val.id == paymentMethod,
                          )?.validTo,
                        )
                    : ''
                }`}
              </i>
            )}
            <PaymentNoticeTradeDiscount />
          </div>
        </PaymentMethodComponent>
      )}
      {deliverTicketTypeList?.length > 0 && (
        <PaymentMethodComponent>
          <div className="title d-flex align-items-center">
            <TicketFormIcon />
            <h3>{translations?.['b2b.txt.ticket-issuance-form'] ?? ''}</h3>
          </div>
          <div className={styles.checkboxContainer}>
            {deliverTicketTypeList?.map(i => {
              const value = i?.id;
              return (
                <StyledCheckbox
                  key={value}
                  checked={value === deliverTicketType}
                  value={value}
                  onChange={handleChangeDeliverTicketType}
                >
                  {i?.name || i?.code}
                </StyledCheckbox>
              );
            })}
          </div>
        </PaymentMethodComponent>
      )}
      <Payment>
        <h3 className="payment-title">
          {translations?.['b2b.txt.info-pay'] ?? ''}
        </h3>
        <div className="payment-content">
          <div
            className={`d-flex align-items-center justify-content-between ${styles.colorBlack} ${styles.fw500} ${styles.fs14}`}
          >
            <p>{translations?.['b2b.txt.numTicketSelected'] ?? ''}</p>
            <p>{`${formatNumber(totalNumberTickets).replaceAll(',', '.')}`}</p>
          </div>
          <div
            className={`d-flex align-items-center justify-content-between ${styles.colorBlack} ${styles.fw500} ${styles.fs16}`}
          >
            <p>{translations?.['b2b.txt.total-amount'] ?? ''}</p>
            <p
              className={styles.colorRed}
              style={{ fontWeight: 600 }}
            >{`${formatNumber(totalPrice).replaceAll(',', '.')} đ`}</p>
          </div>
          <p
            className={`${styles.colorRed} ${styles.fw400} ${styles.fs14}`}
            style={{ margin: 0 }}
          >
            (*){' '}
            <span className={`${styles.textItalic} ${styles.colorBlack}`}>
              {translations?.['b2b.txt.pressCreateOrderToShowOffer'] ?? ''}
            </span>
          </p>
          <p
            className={`${styles.colorRed} ${styles.fw400} ${styles.fs14}`}
            style={{ margin: 0 }}
          >
            (*){' '}
            <span className={`${styles.textItalic} ${styles.colorBlack}`}>
              {translations?.['b2b.txt.updateNewPrice'] ?? ''}
            </span>
          </p>
        </div>
      </Payment>
      <Actions gutter={[16, 10]}>
        <Col span={24}>
          <StyledButton
            textColor="#ffffff"
            width="100%"
            onClick={handleAddons.bind(null, 'PAY')}
            // disabled={!enablePaymentAction || !!disableCreateOrder}
            style={{
              cursor:
                // actionType === 'PAY' ||
                // !enablePaymentAction ||
                // disableCreateOrder
                actionType === 'PAY' ? 'not-allowed' : 'pointer',
              // border:
              //   enablePaymentAction || !disableCreateOrder
              //     ? 'initial'
              //     : 'solid 1px #D9D9D9',
            }}
          >
            {actionType === 'PAY'
              ? 'Loading...'
              : translations?.['b2b.txt.pay-now'] ?? ''}
          </StyledButton>
        </Col>
        <Col span={12}>
          <StyledButton
            textColor="#808080"
            border="solid 1px #808080"
            bgColor="#ffffff"
            width="100%"
            onClick={onGoBack}
          >
            {translations?.['b2b.txt.back'] ?? ''}
          </StyledButton>
        </Col>
        <Col span={12}>
          <StyledButton
            textColor="#ffffff"
            width="100%"
            onClick={handleAddons.bind(null, 'UPDATE')}
            disabled={!!disableCreateOrder}
            style={{
              cursor: actionType === 'UPDATE' ? 'not-allowed' : 'pointer',
            }}
          >
            {actionType === 'UPDATE'
              ? 'Loading...'
              : translations?.['b2b.txt.updateOrder'] ?? ''}
          </StyledButton>
        </Col>
      </Actions>
    </Container>
  );
};

export default PaymentInfo;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: sticky;
  top: 120px;
  @media (max-width: ${DESKTOP_WIDTH - 1}px) {
    position: static;
    margin-top: 32px;
  }
`;

const Payment = styled.div`
  border-radius: 10px;
  background: #fab317;
  padding: 2px;
  h3.payment-title {
    color: #ffffff;
    font-size: 20px;
    font-weight: 600;
    text-transform: uppercase;
    padding: 13px 10px;
    margin: 0;
  }
  .payment-content {
    padding: 24px 16px 31px;
    background: #ffffff;
    border-bottom-left-radius: 10px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
  p {
    margin-bottom: 9px;
  }
`;

const Actions = styled(Row)`
  margin-top: 24px;
`;

const PaymentMethodComponent = styled.div`
  margin-bottom: 30px;
  h3 {
    margin: 0 0 0 8px;
    font-size: 18px;
    font-weight: 600;
    color: #000000;
  }
`;

const StyledCheckbox = styled(Checkbox)`
  &.ant-checkbox-wrapper {
    &:not(:first-child) {
      margin-top: 8px;
      margin-left: 0;
    }
    width: max-content;
    .ant-checkbox-inner {
      border-radius: 50%;
    }
    .ant-checkbox {
      & + span {
        color: #000000;
      }
    }
    .ant-checkbox-checked {
      &:after {
        border-radius: 50%;
      }
    }
  }
`;

const UpdateOrderConfirmMsg = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #1c1b1f;
  text-align: center;
  margin: 0 auto;
  &:not(:first-child) {
    margin-top: 1px;
  }
`;
